import { 
  UserProfile, 
  FinancialConfig, 
  Quote, 
  Material, 
  ProductTemplate, 
  SimpleService,
  Client,
  Supplier,
  WorkOrder,
  Receipt,
  Appointment,
  StaffMember,
  SubscriptionClubPlan,
  StorefrontProfile,
  InventoryBatch,
  StockMovement,
  ClinicalPatient,
  ClinicalConsultation,
  ClinicalVaccination,
  ClinicalExamVault
} from './types';
import { safeStorage } from './utils/safeStorage';

const STORAGE_KEY = 'rmax_data';

interface AppState {
  user: UserProfile | null;
  financialConfig: FinancialConfig | null;
  quotes: Quote[];
  materials: Material[];
  recipes: ProductTemplate[];
  services: SimpleService[];
  clients?: Client[];
  suppliers?: Supplier[];
  workOrders?: WorkOrder[];
  receipts?: Receipt[];
  appointments?: Appointment[];
  staffMembers?: StaffMember[];
  subscriptionClubs?: SubscriptionClubPlan[];
  storefrontProfile?: StorefrontProfile | null;
  inventoryBatches?: InventoryBatch[];
  stockMovements?: StockMovement[];
  clinicalPatients?: ClinicalPatient[];
  clinicalConsultations?: ClinicalConsultation[];
  clinicalVaccinations?: ClinicalVaccination[];
  clinicalExams?: ClinicalExamVault[];
}

const getInitialState = (): AppState => {
  const stored = safeStorage.getItem(STORAGE_KEY);
  if (stored) {
    try {
      const parsed = JSON.parse(stored);
      return {
        ...parsed,
        materials: parsed.materials || [],
        quotes: parsed.quotes || [],
        recipes: parsed.recipes || [],
        services: parsed.services || [],
        clients: parsed.clients || [],
        suppliers: parsed.suppliers || [],
        workOrders: parsed.workOrders || [],
        receipts: parsed.receipts || [],
        appointments: parsed.appointments || [],
        staffMembers: parsed.staffMembers || [],
        subscriptionClubs: parsed.subscriptionClubs || [],
        storefrontProfile: parsed.storefrontProfile || null,
        inventoryBatches: parsed.inventoryBatches || [],
        stockMovements: parsed.stockMovements || [],
        clinicalPatients: parsed.clinicalPatients || [],
        clinicalConsultations: parsed.clinicalConsultations || [],
        clinicalVaccinations: parsed.clinicalVaccinations || [],
        clinicalExams: parsed.clinicalExams || [],
      };
    } catch {
      // Corrupted state - wipe and start fresh
      safeStorage.removeItem(STORAGE_KEY);
    }
  }
  return {
    user: null,
    financialConfig: null,
    quotes: [],
    materials: [],
    recipes: [],
    services: [],
    clients: [],
    suppliers: [],
    workOrders: [],
    receipts: [],
    appointments: [],
    staffMembers: [],
    subscriptionClubs: [],
    storefrontProfile: null,
    inventoryBatches: [],
    stockMovements: [],
    clinicalPatients: [],
    clinicalConsultations: [],
    clinicalVaccinations: [],
    clinicalExams: [],
  };
};

export const saveState = (state: AppState) => {
  try {
    safeStorage.setItem(STORAGE_KEY, JSON.stringify(state));
  } catch (error) {
    console.error('Error saving state to storage:', error);
  }
};

export const loadState = (): AppState => {
  try {
    return getInitialState();
  } catch (error) {
    console.error('Error loading state from localStorage:', error);
    return {
      user: null,
      financialConfig: null,
      quotes: [],
      materials: [],
      recipes: [],
      services: [],
      clients: [],
      suppliers: [],
      workOrders: [],
      receipts: [],
      appointments: [],
      staffMembers: [],
      subscriptionClubs: [],
      storefrontProfile: null,
      inventoryBatches: [],
      stockMovements: [],
      clinicalPatients: [],
      clinicalConsultations: [],
      clinicalVaccinations: [],
      clinicalExams: [],
    };
  }
};

